import { nullSafeGet } from '../../utils/DataAccessUtils';
import { Col, Row } from 'antd';
import { BLACKS_AND_WHITES, STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';
import { CustomCurrencyDisplay } from '../custom_currency_display/CustomCurrencyDisplay';
import React from 'react';

export const DetailsDisplay = ({
	title,
	fieldName,
	currency,
	record = {},
	lastRecord = {},
	displayComparison,
}) => {
	const currentVal = nullSafeGet(fieldName, record);
	const lastVal = nullSafeGet(fieldName, lastRecord);
	const hasChanged = lastVal !== undefined && parseFloat(currentVal) !== parseFloat(lastVal);

	return (
		<Row className="sectionHeaderWrapper" style={{ marginBottom: 8 }}>
			<Col className="sectionHeaderText">{title}</Col>

			{/* This column takes the remaining width */}
			<Col flex="auto">
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						alignItems: 'baseline',
					}}
				>
					{hasChanged && displayComparison && (
						<span
							className="sectionHeaderText2"
							style={{
								textDecoration: 'line-through',
								color: BLACKS_AND_WHITES.blackSecondary,
								marginRight: 12,
							}}
						>
							<CustomCurrencyDisplay value={lastVal} currency={currency} showDenomination={false} />
						</span>
					)}

					<span
						className="sectionHeaderText2"
						style={{
							textAlign: 'right',
							color:
								!hasChanged || displayComparison === false
									? BLACKS_AND_WHITES.blackPrimary
									: parseFloat(lastVal) > parseFloat(currentVal)
									? STOPLIGHT_COLORS.pureGreen
									: STOPLIGHT_COLORS.pureRed,
						}}
					>
						<CustomCurrencyDisplay value={currentVal} currency={currency} />
					</span>
				</div>
			</Col>
		</Row>
	);
};
